import PropTypes from 'prop-types';

import deepEqual from "lib/deepEqual";
import {Layer} from "./Canvas.jsx";

export default class Text extends Layer {
    get defaultStyles() {
        return {
            fontSize: 12,
            lineHeight: null,
            color: "black",
            fontFamily: window.getComputedStyle(document.body).fontFamily
        };
    }

    static displayName = 'Text';

    static propTypes = {
        style: PropTypes.object
    };

    static defaultProps = {
        style: {}
    };

    componentDidMount() {
        this.updateSize();
    }

    updateSize(props = this.props) {
        let {children} = props;
        let text = children;

        let ctx = this.getCtx();
        let combinedStyle = this.getStyles(props);
        ctx.font = `${combinedStyle.fontSize}px ${combinedStyle.fontFamily}`;

        let width = Math.ceil(ctx.measureText(text).width);

        let height = combinedStyle.lineHeight || combinedStyle.fontSize * 1.2;
        this.setSize({width, height});
    }

    doDraw() {
        let text = this.props.children;

        let ctx = this.getCtx();
        let combinedStyle = this.getStyles();

        ctx.font = `normal ${combinedStyle.fontSize}px ${combinedStyle.fontFamily}`;
        ctx.fillStyle = combinedStyle.color;
        ctx.textBaseline = 'top';

        ctx.fillText(text, 0, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (!deepEqual(nextProps.style, this.props.style) || this.props.children != nextProps.children) {
            this.updateSize(nextProps);
            this.markDirty();
        }
    }
}


// WEBPACK FOOTER //
// ./src/kpi/charts/Text.jsx